import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import {
  Container, Header, Icon,
  Menu, Segment
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import CargosView from './CargosView';
import DepartamentosView from './DepartamentosView';
import LocalidadesView from './LocalidadesView';
import RubrosView from './RubrosView';
import SectoresView from './SectoresView';

class MiscView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Header as="h2">
          <Icon name="users" />
          <Header.Content>
            Miscelaneos
            <Header.Subheader>
              Administrar Datos Miscelaneos
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu attached="top" tabular>
          <Menu.Item
            as={Link} to="/miscelaneos/cargos"
            active={!!window.location.pathname.match(new RegExp(`^/miscelaneos/cargos/?$`))}
            name="cargos" />
          <Menu.Item
            as={Link} to="/miscelaneos/departamentos"
            active={!!window.location.pathname.match(new RegExp(`^/miscelaneos/departamentos/?$`))}
            name="departamentos" />
          <Menu.Item
            as={Link} to="/miscelaneos/localidades"
            active={!!window.location.pathname.match(new RegExp(`^/miscelaneos/localidades/?$`))}
            name="localidades" />
          <Menu.Item
            as={Link} to="/miscelaneos/rubros"
            active={!!window.location.pathname.match(new RegExp(`^/miscelaneos/rubros/?$`))}
            name="rubros" />
          <Menu.Item
            as={Link} to="/miscelaneos/sectores"
            active={!!window.location.pathname.match(new RegExp(`^/miscelaneos/sectores/?$`))}
            name="sectores" />
        </Menu>
        <Route path={`${this.props.match.url}/cargos`} render={() => {
          return (
            <Segment attached="bottom">
              <CargosView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/departamentos`} render={() => {
          return (
            <Segment attached="bottom">
              <DepartamentosView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/localidades`} render={() => {
          return (
            <Segment attached="bottom">
              <LocalidadesView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/rubros`} render={() => {
          return (
            <Segment attached="bottom">
              <RubrosView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/sectores`} render={() => {
          return (
            <Segment attached="bottom">
              <SectoresView />
            </Segment>
          );
        }} />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    MiscView.mapStateToProps,
    MiscView.mapDispatchToProps
  )(MiscView)
);



// WEBPACK FOOTER //
// ./client/components/pages/misc/MiscView.js